/**
 * Centralised brand mark. Use this in every site/admin/auth header so a
 * single image swap propagates everywhere.
 */
export default function BrandLogo({
  size = "md",
  tone = "light",
  className = "",
  alt = "The AI Took My Job",
  testid,
}) {
  const dims = size === "lg" ? "h-12 w-12" : size === "sm" ? "h-7 w-7" : "h-9 w-9";
  // `tone` controls the chip background behind the image so the logo reads
  // well on both light and dark surfaces.
  const chip =
    tone === "dark"
      ? "bg-white"
      : tone === "transparent"
        ? ""
        : "bg-slate-50 ring-1 ring-slate-200";
  return (
    <span
      className={`inline-flex ${dims} items-center justify-center rounded-xl overflow-hidden ${chip} ${className}`}
      data-testid={testid}
    >
      <img
        src="/brand-logo.jpg"
        alt={alt}
        className="h-full w-full object-contain"
        draggable={false}
      />
    </span>
  );
}
